import { render } from "./ProgressBar.vue?vue&type=template&id=5636f375&scoped=true"
import script from "./ProgressBar.vue?vue&type=script&lang=js"
export * from "./ProgressBar.vue?vue&type=script&lang=js"

import "./ProgressBar.vue?vue&type=style&index=0&id=5636f375&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5636f375"]])

export default __exports__